import store from "../../Redux/store";
import {
  setOwnersByProject,
  countOwnersByProject,
  setSelectedProject,
} from "../Infrastructure/Owners.reducer";

export function saveListOwnersByProject(records) {
  store.dispatch(setOwnersByProject(records));
}
export function saveCountOwnersByProject(count) {
  store.dispatch(countOwnersByProject(count));
}
export function saveSelectedProject(projectId) {
  store.dispatch(setSelectedProject(projectId));
}
